export const shippingMethodClickAndCollectProps = () => ({
  modeCommande: {
    type: Object,
    required: true
  },
  service: {
    type: Object,
    required: true
  },
  infosPossibleServices: {
    type: [Array, Object],
    required: true
  },
  magasinName: {
    type: String,
    required: true
  },
  horairesTable: {
    type: Object,
    required: false,
    default: null
  },
  infosModeCommande: {
    type: Object,
    required: false,
    default: null
  }
})

export const shippingMethodClickAndCollectEmits = () => ([
  "applyUpdateModeCommande"
])

export const useShippingMethodClickAndCollect = (props, context) => {
  const timetable = computed(() => {
    if (!props.horairesTable) {
      return []
    }
    return [...props.horairesTable.timetable].sort((a, b) => a.jour_numero - b.jour_numero);
  })
  const msgNonRetrait = computed(() => {
    return props.service && props.service.info_non_retrait
  })
  const applyUpdateModeCommande = () => {
    context.emit("applyUpdateModeCommande", props.service.id)
  }

  return {
    timetable,
    msgNonRetrait,
    applyUpdateModeCommande
  }
}